/**
 * Adobe Analytics Utility
 * Tracks page views and user actions for the Mable application
 */

declare global {
  interface Window {
    _satellite?: {
      track: (event: string) => void;
    };
  }
}

let analyticsDataLayer: Record<string, unknown> | null = null;

/**
 * Track a user action (click, form submission, etc.)
 * @param pageName - Name of the current page
 * @param userId - ID of the current user
 * @param actionName - Description of the action performed
 */
export function trackUserAction(
  pageName: string,
  userId: string,
  actionName: string
): void {
  analyticsDataLayer = {
    pageInfo: {
      pageName,
      userID: userId,
      applicationName: "DU Next Gen",
      actionName,
      moduleName: "Mable"
    }
  };

  if (typeof window !== "undefined" && typeof window._satellite !== "undefined") {
    window._satellite.track("action");
  }
}

/**
 * Track a page view (on page load)
 * @param pageName - Name of the page being viewed
 * @param userId - ID of the current user
 */
export function trackPageView(pageName: string, userId: string): void {
  analyticsDataLayer = {
    pageInfo: {
      pageName,
      userID: userId,
      moduleName: "Mable",
      applicationName: "DU Next Gen"
    }
  };

  if (typeof window !== "undefined" && typeof window._satellite !== "undefined") {
    window._satellite.track("pageView");
  }
}

/**
 * Get the current analytics data layer
 */
export function getAnalyticsDataLayer(): Record<string, unknown> | null {
  return analyticsDataLayer;
}
